module.exports = __webpack_public_path__ + "/images/cover-onboading-guest-screenshot.92d547e.png";